import React, { Component, useState, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import TempSlider from "../../../../commons/components/input/Slider";
import { Message } from "element-react";
import ToggleSwitch from "../../../../commons/components/input/ToggleSwitch";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css';
import MakeKey from "../../../../commons/services/MakeKey";
import MS from "../../../../commons/services/Moment";
import PS from "../../MonitoringApiService";
import { detailCarrierCard } from "./translationUiConst";

const KEYS = {
  boilerTempCommandKind: 8,
  storageTankTempCommandKind: 6,
  boilerTempObjKey: "indoorSetTemp", // 보일러 온도 = indoorSetTemp
  storageTankTempObjKey: "hstSetTemp", // 축열조 온도 = hstSetTemp
}
const KIND = {
  boiler: 60,
  storageTank: 60,
}

const CONTROL_KIND = {
  indoor: 8,
  storageTank: 6,
};

class DetailCarrierCard extends Component {
  constructor(props) {
    super(props);

    const { data, openDeviceId } = props;
    const boilerList = [];
    let currentBoilerIndex = 0;
  
    if (data?.boiler?.device) {
      boilerList.push(data.boiler);
    }
    if (data?.children && data.children.length > 0) {
      data.children.forEach((child) => {
        boilerList.push(child);
      });
    }
  
    if (boilerList.length > 0 && openDeviceId) {
      const sameDeviceIndex = boilerList.findIndex(
        (boiler) => boiler.device.id === openDeviceId.boiler
      );
      if (sameDeviceIndex !== -1) {
        currentBoilerIndex = sameDeviceIndex;
      }
    }
  
    this.state = {
      boilerList,
      currentBoilerIndex,
      showGauge: null, // { type: 'storageTank'|'boiler', value, min, max, kind, controlKind, tempKey, label }
    };
  }


  async componentDidMount() {
    const { boilerList } = this.state;
    
    if (boilerList.length === 0) return;

    for (let i = 0; i < boilerList.length; i++) {
      const boiler = boilerList[i];
      const deviceKey = MakeKey.carrier({
        siteNo: boiler.device.siteNo,
        rtuNo: boiler.device.rtuNo,
        deviceNo: boiler.device.deviceNo,
      })
      try {
        const param = {
          carrierSerialNos: [deviceKey],
          date: MS.current('YYYY-MM-DD'), // 오늘 날짜
        }
        const res = await PS.getEmsCarrierSum(param);
        if (res && res.length > 0) {
          const consPowerToday = res[0]?.day_total_cons_power ?? 0;

          if (boiler?.carrier) {
            boiler.carrier.consPowerToday = consPowerToday;
          }
          if (this.props.onConsPowerTodayUpdate) {
            this.props.onConsPowerTodayUpdate(boiler.device.id, consPowerToday);
          }
        }
      } catch (error) {
        console.error("Error fetching carrier data:", error);
        continue; // 에러가 발생해도 다음 보일러로 넘어감
      }
    }

    // consPowerToday는 boiler.carrier를 직접 mutate하므로, state를 갱신해 리렌더링을 트리거함
    this.setState((prevState) => ({ boilerList: [...prevState.boilerList] }));
  }

  isErrorDevice(matchedBoilerStorageTankData) {
    const { boiler, storageTank, children } = matchedBoilerStorageTankData;
    let isError = false;

    if (children && children.length > 0) {
      // 하위 보일러가 있는 경우
      children.forEach((child) => {
        if (!child.carrier) {
          isError = true; // 하위 보일러 패킷 데이터 없을 경우
          return;
        }
        if (child.carrier && child.carrier.powerState === 0) {
          isError = true; // 하위 보일러 전원 꺼짐
          return;
        }
      });
    }

    if (!boiler?.carrier) isError = true; // 패킷 데이터 없을 경우
    // if (boiler?.carrier && boiler.carrier.powerState === 0) isError = true; // 보일러 전원 꺼짐

    return isError;
  }

  render() {
    const {
      isActiveDevice,
      data,
      handleShowDetailInfo,
      isTempContr,
      handleTargetTemp,
      handleSlideTemp,
      handleSlideTempFetchApi,
      handleGaugeTempSet,
      handlePowerSwitch,
      setTargetRef,
      t,
      i18n,
    } = this.props;

    const {
      boilerList,
      currentBoilerIndex,
      showGauge,
    } = this.state;

    const currentBoiler = boilerList[currentBoilerIndex];

    const {
      boiler: {
        device: boilerDevice,
        carrier: boilerCarrier,
      },
      storageTank: {
        device: storageTankDevice,
        carrier: storageTankCarrier,
      },
    } = data;
    return (
      <ContentBoxWrapper 
        key={boilerDevice.id}   
        ref={isActiveDevice ? setTargetRef : null}
      >
        <ContentBox
          isActive={isActiveDevice}
          isError={this.isErrorDevice(data)}
          // onClick={() => handleShowDetailInfo(data)}
          onMouseDown={(e) => {
            // 클릭 시작 위치가 이 컴포넌트 내부인지 플래그 저장
            this.mouseDownTarget = e.currentTarget;
          }}
          onMouseUp={(e) => {
            if (this.mouseDownTarget === e.currentTarget) {
              handleShowDetailInfo(data);
            }
            this.mouseDownTarget = null;
          }}
        >
          <p className="cont-name">{`${boilerDevice.name}`}{/* ` (${storageTankDevice?.name ?? "--"})` */}</p>
          <SectionWrapper>
            {/* 축열조 축열 온도 */}
            <section>
              <div className="section-tit">
                <p>{t('key254')}</p>
              </div>
              <SectionInner>
                <dl className="current-box storage-tank-temp">
                  <dt>{t('key255')}</dt>
                  <dd>
                    <p>
                      {boilerCarrier ? boilerCarrier.hstTemp : "--"}{" "}
                      <span className="temp-unit">°C</span>
                    </p>
                  </dd>
                </dl>
                <dl className="target-box">
                  <dt>{t('key256')}</dt>
                  <span className="temp-range-text">(30°C ~ 80°C)</span>
                  <dd>
                    <p>
                      {boilerCarrier ? boilerCarrier.hstSetTemp : "--"}{" "}
                      <span className="temp-unit">°C</span>
                    </p>
                  </dd>
                  <SliderRow>
                    <div className="slider-wrap">
                      <TempSlider
                        value={Number(boilerCarrier?.hstSetTemp) || 0}
                        max={80}
                        min={30}
                        disabled={!isTempContr(data?.boiler?.device)}
                        onChange={handleSlideTemp({
                          data: data?.boiler,
                          min: 30,
                          max: 80,
                          tempKey: KEYS.storageTankTempObjKey,
                        })}
                        onClick={(event) => event.stopPropagation()}
                        // onMouseUp={handleSlideTempFetchApi({
                        //   data: data?.boiler,
                        //   min: 30,
                        //   max: 80,
                        //   kind: KIND.storageTank,
                        //   controlKind: CONTROL_KIND.storageTank,
                        //   tempKey: KEYS.storageTankTempObjKey,
                        // })}
                      />
                    </div>
                    <SliderSettingBtn
                      disabled={!isTempContr(data?.boiler?.device) || !boilerCarrier}
                      onMouseDown={(e) => e.stopPropagation()}
                      onMouseUp={(e) => e.stopPropagation()}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isTempContr(data?.boiler?.device) || !boilerCarrier) return;
                        this.setState({
                          showGauge: {
                            type: "storageTank",
                            value: Number(boilerCarrier.hstSetTemp) || 30,
                            kind: KIND.storageTank,
                            tempKey: KEYS.storageTankTempObjKey,
                            label: t("key256"),
                            carrierId: boilerDevice.id,
                          },
                        });
                      }}
                    >
                      설정
                    </SliderSettingBtn>
                  </SliderRow>
                </dl>
              </SectionInner>
            </section>

            {/* 보일러 실내 온도 */}
            <section
              style={{
                paddingLeft: "10px",
              }}
            >
              <div className="section-tit">
                <p className="boiler-title">{t('key257')}</p>
                <ToggleSwitch
                  isChecked={
                    boilerCarrier?.powerState === 1
                  }
                  disabled={this.isErrorDevice(data)}
                  name="power"
                  htmlFor={`switch-${boilerDevice.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.isErrorDevice(data)) {
                      return;
                    }
                    if (!boilerCarrier?._id) {
                      Message({
                        iconClass: "cancel",
                        type: "warning",
                        message: "보일러 데이터가 없습니다.",
                      });
                      return;
                    };
                    handlePowerSwitch(boilerCarrier._id)
                  }}
                />
              </div>
              <SectionInner
                style={{
                  gap: "8px"
                }}
              >
                <div
                  style={{ 
                    width: "100%", 
                    height: "100%", 
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    overflow: "hidden",
                    zIndex: 1
                  }}
                  onClick={(event) =>{
                    event.stopPropagation();
                    event.preventDefault();
                  }}
                  onMouseDown={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                  }}
                >
                  <Swiper
                    slidesPerView={1.1}
                    spaceBetween={3}
                    centeredSlides={true}
                    style={{ width: '100%', height: '100%' }}
                    onSlideChange={(Swiper) => {
                      this.setState({ 
                        currentBoilerIndex: Swiper.realIndex 
                      });
                    }}
                    // loop={boilerList.length > 1}
                    direction="horizontal"
                    initialSlide={currentBoilerIndex}
                    // key={currentBoilerIndex}
                  >
                    {
                      boilerList.map((boiler, index) => {
                        const isParentBoiler = storageTankDevice?.id === boiler.device.parentId;
                        
                        return (
                          <SwiperSlide key={boiler.device.id} style={{ zIndex: 1 }}>
                            <dl className="current-box">
                              <dt>{isParentBoiler ? t('key258') : /* 주석처리: t('key625') "(하위)" */ ""}</dt>
                              <dt>{t('key259')}</dt>
                              <dd>
                                <p>
                                  {/* 임시 노출: 기존 로직 주석처리 { boiler?.carrier ? boiler?.carrier?.indoorTemp : "--"} */}
                                  {"--"}{" "}
                                  {/* <span className="temp-unit">°C</span> */}
                                </p>
                              </dd>
                            </dl>
                          </SwiperSlide>
                        )
                      })
                    }
                  </Swiper>
                </div>
                <dl className="target-box">
                  <dt>{t('key260')}</dt>
                  <span className="temp-range-text">(17°C ~ 30°C)</span>
                  <dd>
                    <p>
                      {/* 임시 노출: 기존 로직 주석처리 {boilerCarrier?.indoorSetTemp || "--"} */}
                      {"--"}{" "}
                      {/* <span className="temp-unit">°C</span> */}
                    </p>
                  </dd>
                  <SliderRow>
                    <div className="slider-wrap">
                      <TempSlider
                        value={Number(boilerCarrier?.indoorSetTemp) || 0}
                        max={30}
                        min={17}
                        disabled={true} // 임시 비활성화 (기존: !isTempContr(data?.boiler?.device))
                        onChange={handleSlideTemp({
                          data: data?.boiler,
                          min: 17,
                          max: 30,
                          tempKey: KEYS.boilerTempObjKey,
                        })}
                        onClick={(event) => event.stopPropagation()}
                      />
                    </div>
                    <SliderSettingBtn
                      disabled={true} // 임시 비활성화 (기존: !isTempContr(data?.boiler?.device) || !boilerCarrier)
                      onMouseDown={(e) => e.stopPropagation()}
                      onMouseUp={(e) => e.stopPropagation()}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isTempContr(data?.boiler?.device) || !boilerCarrier) return;
                        this.setState({
                          showGauge: {
                            type: "boiler",
                            value: Number(boilerCarrier.indoorSetTemp) || 17,
                            kind: KIND.boiler,
                            tempKey: KEYS.boilerTempObjKey,
                            label: t("key260"),
                            carrierId: boilerDevice.id,
                          },
                        });
                      }}
                    >
                      설정
                    </SliderSettingBtn>
                  </SliderRow>
                </dl>
              </SectionInner>
            </section>
          </SectionWrapper>
        </ContentBox>

        {showGauge && (
          <TempSettingModal
            value={showGauge.value}
            type={showGauge.type}
            carrierId={showGauge.carrierId}
            kind={showGauge.kind}
            label={showGauge.label}
            onClose={() => this.setState({ showGauge: null })}
            onLocalUpdate={(newValue) => {
              handleGaugeTempSet({
                data: data.boiler,
                tempKey: showGauge.tempKey,
                value: newValue,
              });
            }}
          />
        )}

        {isActiveDevice && (
          <ContentDetail dtWidth={detailCarrierCard(i18n).dtWidth}>
            <DeviceDetailHeader>              
              <p className="head">{currentBoiler?.device?.name || ""} 세부정보</p>
              <span>{currentBoiler?.carrier?.time || "--"}</span>
            </DeviceDetailHeader>
            <div className="info-list">
              <dl>
                <dt>{t('key262')}</dt>
                <dd>{currentBoiler?.carrier?.totalConsPower || "--"} kWh</dd>
              </dl>
              <dl>
                <dt>{t('key263')}</dt>
                <dd>{currentBoiler?.carrier?.heatingMeteringAmount || "--"} kWh</dd>
              </dl>
              <dl>
                <dt>{t('key264')}</dt>
                <dd>{currentBoiler?.carrier?.powerState === 1 ? "on" : "off"}</dd>
              </dl>
              <dl>
                <dt>{t('key265')}</dt>
                <dd>
                  {currentBoiler?.carrier?.powerConsCurrent !== undefined && currentBoiler?.carrier?.powerConsCurrent !== null
                    ? currentBoiler?.carrier.powerConsCurrent === 0
                      ? "0"
                      : currentBoiler?.carrier.powerConsCurrent
                    : "--"}{" "}
                  <span>W</span>
                </dd>
              </dl>
              <dl>
                <dt>{t('key266')}</dt>
                <dd>
                  {(currentBoiler?.carrier?.consPowerToday !== undefined && currentBoiler?.carrier?.consPowerToday !== null)
                    ? Number(currentBoiler.carrier.consPowerToday).toFixed(2)
                    : "--"}{" "}
                  <span>kWh</span>
                </dd>
              </dl>
              <dl>
                <dt>{t('key267')}</dt>
                <dd>{carrierMode(currentBoiler?.carrier?.ucOpMode)}</dd>
              </dl>
            </div>
          </ContentDetail>
        )}
      </ContentBoxWrapper>
    )
  }
}

const ContentBoxWrapper = styled.div`
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContentBox = styled.div`
  border: 1px solid #e5e6e8;
  border-radius: 12px;
  cursor: pointer;
  ${({ isActive }) => isActive && `
    box-shadow: 0 0 10px rgba(11, 148, 63, 0.5);`}
  ${({ isError }) => isError && `
    box-shadow: 0px 0px 10px 0px #FF626299;
  `}

  &:hover {
    ${({ isError }) => isError ? `
      box-shadow: 0px 0px 10px 0px #FF626299;
    `: `box-shadow: 0 0 10px rgba(11, 148, 63, 0.5);`}
    
  }
  .cont-name {
    font-size: 16px;
    font-weight: bold;
    color: #191919;
    padding: 9px 20px;
    border-radius: 12px 12px 0 0;
    background-color: #f2f3f5;
    border-bottom: 1px solid #e5e6e8;
  }
`;

const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  section {
    padding: 20px;
    &:first-child {
      border-right: 1px solid #e5e6e8;
    }
  }
  .section-tit {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-flow: column;
    align-items: center;
    padding-bottom: 20px;
    p {
      height: 28px;
      line-height: 28px;
      font-size: 15px;
      font-weight: 500;
      color: #191919;
    }
    .boiler-title {
      margin-left: 10px;
    }
  }
`;
const SectionInner = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 130px 1fr;
  align-items: center;
  gap: 12px;
  dl {
    border-radius: 10px;
    padding: 15px;
  }
  .storage-tank-temp {
    margin: 0 5px;
  }
  .current-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #E8F4E7;
    height: 100%;
  }
  .target-box {
    background-color: #f2f3f5;
  }
  .slider-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    items-align: center;
  }
  .temp-range-text {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 14px;
    font-weight: 500;
    color: #797979;
  }
  dt {
    font-size: 14px;
    font-weight: 500;
    color: #797979;
    text-align: center;
    padding-bottom: 10px;
  }
  dd {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    // padding: 0 7%;
    p {
      display: inline-block;
      vertical-align: middle;
      font-size: 24px;
      color: #191919;
      font-weight: 600;
    }
    .temp-unit {
      font-size: 18px;
    }
    .count-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 29px;
      height: 29px;
      border-radius: 50%;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        background-repeat: no-repeat;
        width: 15px;
        height: 15px;
        background-size: contain;
      }
    }
    .minus-btn {
      
      border: 1px solid #b7b7b7;
      background-color: #fff;
      &::after {
        background-image: url("/images/ctors/icon/count-btn-icon.png");
        transform: translate(-50%, -50%) rotate(180deg);
      }
      &:active {
        background-color: #4A4A4A;
      }
      &:active::after {
        background-image: url("/images/ctors/icon/count-btn-hover.png");
        transform: translate(-50%, -50%) rotate(180deg);
      }
    }
    .plus-btn {
      border: 1px solid #b7b7b7;
      background-color: #fff;
      &::after {
        background-image: url("/images/ctors/icon/count-btn-icon.png");
        transform: translate(-50%, -50%);
      }
      &:active {
        background-color: #4A4A4A;
      }
      &:active::after {
        background-image: url("/images/ctors/icon/count-btn-hover.png");
        transform: translate(-50%, -50%);
      }
    }
  }
`;

const ContentDetail = styled.div`
  background-color: #f2f3f5;
  border-radius: 12px;
  padding: 20px;
  margin-top: 12px;
  // .head {
  //   font-size: 16px;
  //   font-weight: 600;
  //   padding-bottom: 12px;
  //   border-bottom: 1px solid #b5b5b5;
  // }
  .info-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    dt,
    dd {
      display: inline-block;
      vertical-align: middle;
      padding: 10px 0;
      font-size: 14px;
      font-weight: 500;
      color: #191919;
    }
    dt {
      ${({ dtWidth }) => dtWidth ? `width: ${dtWidth};` : `width: 140px;`}
    dd {
      padding-left: 30px;
    }
    span {
      display: inline-block;
      vertical-align: top;
    }
  }
`;

const DeviceDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #b5b5b5;

  .head {
    font-weight: 600;
  }
  span {
    font-size: 14px;
    color: #797979;
  }
`;

function carrierMode(ucOpMode) {
  switch (ucOpMode) {
    case 0: return "정지";
    case 1: return "냉방";
    case 2: return "난방";
    case 4: return "난방";
    default: return "--";
  }
}

// ─── 온도 설정 확인 모달 ─────────────────────────────────────────────────────

function TempSettingModal({ value, type, carrierId, kind, label, onLocalUpdate, onClose }) {
  const [screen, setScreen] = useState('confirm'); // 'confirm' | 'done'
  const [loading, setLoading] = useState(false);

  const controllItem = type === 'storageTank' ? "02" : "03";
  const tempLabel = type === 'storageTank' ? '축열조온도' : '실내온도';

  const handleApiSubmit = async () => {
    setLoading(true);
    try {
      const item = {
        kind,
        deviceId: carrierId,
        controllItems: [controllItem],
        controllValues: [String(value)],
      };
      await axios.post("/api/device/controll", item);
      onLocalUpdate(value);
      setScreen('done');
    } catch (error) {
      console.error("온도 설정 실패", error);
      alert("온도 설정에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  if (screen === 'done') {
    return (
      <GaugeOverlay onMouseDown={(e) => e.stopPropagation()}>
        <GaugePanel onMouseDown={(e) => e.stopPropagation()}>
          <DoneMessage>
            히트펌프로 설정을 전달 하였습니다.<br />
            몇 분 후에 새로운 주기 데이터를 받으면 화면에 업데이트 됩니다.
          </DoneMessage>
          <GaugeBtnGroup>
            <button className="confirm" style={{ width: "100%" }} onClick={onClose}>완료</button>
          </GaugeBtnGroup>
        </GaugePanel>
      </GaugeOverlay>
    );
  }

  return (
    <GaugeOverlay onMouseDown={(e) => { e.stopPropagation(); onClose(); }}>
      <GaugePanel onMouseDown={(e) => e.stopPropagation()}>
        <ConfirmMessage>
          {tempLabel}를 <strong>{value}°C</strong>로 설정하시겠습니까?
        </ConfirmMessage>
        <GaugeBtnGroup>
          <button className="cancel" onClick={onClose}>취소</button>
          <button className="confirm" disabled={loading} onClick={handleApiSubmit}>
            {loading ? '전송중...' : '설정'}
          </button>
        </GaugeBtnGroup>
      </GaugePanel>
    </GaugeOverlay>
  );
}

/* ── TempGaugeModal (반원 게이지 팝업 - 주석처리) ──────────────────────────────
const CX = 150, CY = 145, R = 115, STROKE = 18;

function polarToXY(angleDeg) {
  const rad = (angleDeg * Math.PI) / 180;
  return { x: CX + R * Math.cos(rad), y: CY - R * Math.sin(rad) };
}

function valueToAngle(v, min, max) {
  return 180 - ((v - min) / (max - min)) * 180;
}

function TempGaugeModal({ value, min, max, label, type, carrierId, kind, onLocalUpdate, onClose }) {
  const [tempValue, setTempValue] = useState(Math.max(min, Math.min(max, value || min)));
  const [screen, setScreen] = useState('gauge'); // 'gauge' | 'confirm' | 'done'
  const [loading, setLoading] = useState(false);
  const svgRef = useRef(null);
  const isDragging = useRef(false);

  const handleAngle = valueToAngle(tempValue, min, max);
  const handlePos = polarToXY(handleAngle);
  const trackStart = polarToXY(180);
  const trackEnd = polarToXY(0);
  const trackPath = `M ${trackStart.x} ${trackStart.y} A ${R} ${R} 0 0 1 ${trackEnd.x} ${trackEnd.y}`;

  const vPath = (() => {
    if (handleAngle >= 179) return null;
    const start = polarToXY(180);
    const end = polarToXY(handleAngle);
    const largeArc = (180 - handleAngle) >= 180 ? 1 : 0;
    return `M ${start.x} ${start.y} A ${R} ${R} 0 ${largeArc} 1 ${end.x} ${end.y}`;
  })();

  const updateFromEvent = (e) => {
    if (!svgRef.current) return;
    const rect = svgRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const mx = ((clientX - rect.left) / rect.width) * 300;
    const my = ((clientY - rect.top) / rect.height) * 200;
    const dx = mx - CX;
    const dy = CY - my;
    let angle = (Math.atan2(dy, dx) * 180) / Math.PI;
    angle = Math.max(0, Math.min(180, angle));
    const normalized = 1 - angle / 180;
    const newVal = Math.round(min + normalized * (max - min));
    setTempValue(Math.max(min, Math.min(max, newVal)));
  };

  const onMouseDownHandle = (e) => { e.stopPropagation(); isDragging.current = true; };
  const onMouseMove = (e) => { if (!isDragging.current) return; e.stopPropagation(); updateFromEvent(e); };
  const onMouseUp = () => { isDragging.current = false; };
  const onTouchStart = (e) => { e.stopPropagation(); isDragging.current = true; updateFromEvent(e); };
  const onTouchMove = (e) => { if (!isDragging.current) return; e.stopPropagation(); updateFromEvent(e); };
  const onTouchEnd = () => { isDragging.current = false; };

  const controllItem = type === 'storageTank' ? "02" : "03";
  const tempLabel = type === 'storageTank' ? '축열조온도' : '실내온도';

  const handleApiSubmit = async () => {
    setLoading(true);
    try {
      const item = {
        kind,
        deviceId: carrierId,
        controllItems: [controllItem],
        controllValues: [String(tempValue)],
      };
      await axios.post("/api/device/controll", item);
      onLocalUpdate(tempValue);
      setScreen('done');
    } catch (error) {
      console.error("온도 설정 실패", error);
      alert("온도 설정에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  // 확인 팝업
  if (screen === 'confirm') {
    return (
      <GaugeOverlay onMouseDown={(e) => e.stopPropagation()}>
        <GaugePanel onMouseDown={(e) => e.stopPropagation()}>
          <ConfirmMessage>
            {tempLabel}를 <strong>{tempValue}°C</strong>로 설정하시겠습니까?
          </ConfirmMessage>
          <GaugeBtnGroup>
            <button className="cancel" onClick={() => setScreen('gauge')}>취소</button>
            <button className="confirm" disabled={loading} onClick={handleApiSubmit}>
              {loading ? '전송중...' : '설정'}
            </button>
          </GaugeBtnGroup>
        </GaugePanel>
      </GaugeOverlay>
    );
  }

  // 완료 팝업
  if (screen === 'done') {
    return (
      <GaugeOverlay onMouseDown={(e) => e.stopPropagation()}>
        <GaugePanel onMouseDown={(e) => e.stopPropagation()}>
          <DoneMessage>
            히트펌프로 설정을 전달 하였습니다.<br />
            몇 분 후에 새로운 주기 데이터를 받으면 화면에 업데이트 됩니다.
          </DoneMessage>
          <GaugeBtnGroup>
            <button className="confirm" style={{ width: "100%" }} onClick={onClose}>완료</button>
          </GaugeBtnGroup>
        </GaugePanel>
      </GaugeOverlay>
    );
  }

  // 게이지 화면
  return (
    <GaugeOverlay onMouseDown={(e) => { e.stopPropagation(); onClose(); }}>
      <GaugePanel
        onMouseDown={(e) => e.stopPropagation()}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <GaugeLabel>{label}</GaugeLabel>
        <GaugeRow>
          <div style={{ flex: 1, minWidth: 0 }}>
            <svg
              ref={svgRef}
              viewBox="0 0 300 200"
              style={{ width: "100%", display: "block", overflow: "visible" }}
            >
              <path d={trackPath} fill="none" stroke="#e5e6e8" strokeWidth={STROKE} strokeLinecap="round" />
              {vPath && <path d={vPath} fill="none" stroke="#0db14b" strokeWidth={STROKE} strokeLinecap="round" />}
              <circle cx={handlePos.x} cy={handlePos.y} r={17} fill="#0db14b" stroke="#fff" strokeWidth={3} style={{ cursor: "grab", touchAction: "none" }} onMouseDown={onMouseDownHandle} onTouchStart={onTouchStart} />
              <circle cx={handlePos.x} cy={handlePos.y} r={5} fill="#fff" />
              <text x={trackStart.x} y={trackStart.y + 24} textAnchor="middle" fontSize="13" fill="#aaa">{min}°</text>
              <text x={trackEnd.x} y={trackEnd.y + 24} textAnchor="middle" fontSize="13" fill="#aaa">{max}°</text>
              <text x={CX} y={CY - 8} textAnchor="middle" dominantBaseline="middle" fontSize="48" fontWeight="bold" fill="#191919">{tempValue}</text>
              <text x={CX} y={CY + 34} textAnchor="middle" fontSize="18" fill="#888">°C</text>
            </svg>
          </div>
          <GaugeSettingBtn
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => { e.stopPropagation(); setScreen('confirm'); }}
          >
            설정
          </GaugeSettingBtn>
        </GaugeRow>
        <GaugeBtnGroup>
          <button className="cancel" style={{ width: "100%" }} onMouseDown={(e) => e.stopPropagation()} onClick={onClose}>취소</button>
        </GaugeBtnGroup>
      </GaugePanel>
    </GaugeOverlay>
  );
}
── 주석 끝 ─────────────────────────────────────────────────────────────────── */

const GaugeOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const GaugePanel = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 28px 32px 24px;
  width: 340px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  user-select: none;
`;

const SliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  .slider-wrap {
    flex: 1;
    min-width: 0;
  }
`;

const SliderSettingBtn = styled.button`
  flex-shrink: 0;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  background: #0db14b;
  color: #fff;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  &:hover:not(:disabled) { background: #6a50e0; }
  &:disabled { opacity: 0.4; cursor: default; }
`;

const GaugeBtnGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 16px;
  button {
    flex: 1;
    padding: 11px 0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .cancel {
    background: #f2f3f5;
    color: #555;
    border: 1px solid #e5e6e8;
  }
  .confirm {
    background: #0db14b;
    color: #fff;
    border: none;
    &:disabled { opacity: 0.6; cursor: default; }
  }
`;

const ConfirmMessage = styled.p`
  font-size: 15px;
  color: #191919;
  text-align: center;
  padding: 30px 0 24px;
  line-height: 1.7;
  strong {
    font-size: 20px;
    color: #0db14b;
    font-weight: 700;
  }
`;

const DoneMessage = styled.p`
  font-size: 14px;
  color: #555;
  text-align: center;
  padding: 30px 0 24px;
  line-height: 1.8;
`;

export default DetailCarrierCard;